"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaPlanoConta = exports.yupPlanoConta = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupPlanoConta = yup.object({
    descricao: yup.string().required().default('').max(71).label('Descricao'),
    conta: yup.string().default('').max(9).label('Conta'),
    sistema: yup.boolean().required().default(false).label('Sistema'),
    valorAnterior: yup.number().notRequired().label('Valor Anterior'),
    valorJaneiro: yup.number().notRequired().label('Valor Janeiro'),
    valorFevereiro: yup.number().notRequired().label('Valor Fevereiro'),
    valorMarco: yup.number().notRequired().label('Valor Marco'),
    valorAbril: yup.number().notRequired().label('Valor Abril'),
    valorMaio: yup.number().notRequired().label('Valor Maio'),
    valorJulho: yup.number().notRequired().label('Valor Julho'),
    valorJunho: yup.number().notRequired().label('Valor Junho'),
    valorAgosto: yup.number().notRequired().label('Valor Agosto'),
    valorSetembro: yup.number().notRequired().label('Valor Setembro'),
    valorOutubro: yup.number().notRequired().label('Valor Outubro'),
    valorNovembro: yup.number().notRequired().label('Valor Novembro'),
    valorDezembro: yup.number().notRequired().label('Valor Dezembro'),
    valorTotal: yup.number().notRequired().label('Valor Anterior'),
    valorJaneiroPrev: yup.number().notRequired().label('Valor Janeiro Previsto'),
    valorFevereiroPrev: yup.number().notRequired().label('Valor Fevereiro Previsto'),
    valorMarcoPrev: yup.number().notRequired().label('Valor Marco Previsto'),
    valorAbrilPrev: yup.number().notRequired().label('Valor Abril Previsto'),
    valorMaioPrev: yup.number().notRequired().label('Valor Maio Previsto'),
    valorJulhoPrev: yup.number().notRequired().label('Valor Julho Previsto'),
    valorJunhoPrev: yup.number().notRequired().label('Valor Junho Previsto'),
    valorAgostoPrev: yup.number().notRequired().label('Valor Agosto Previsto'),
    valorSetembroPrev: yup.number().notRequired().label('Valor Setembro Previsto'),
    valorOutubroPrev: yup.number().notRequired().label('Valor Outubro Previsto'),
    valorNovembroPrev: yup.number().notRequired().label('Valor Novembro Previsto'),
    valorDezembroPrev: yup.number().notRequired().label('Valor Dezembro Previsto'),
    valorTotalPrev: yup.number().notRequired().label('Valor Anterior Previsto'),
    dataAtual: (0, utils_1.sge2Date)().default(null).nullable().label('Data Atual'),
    mascara: yup.string().default('').max(18).label('Mascara'),
    codigoExterno: yup.string().default('').max(10).label('Codigo Externo'),
    inativo: yup.boolean().required().default(false).label('Inativo'),
    recalcula: yup.boolean().required().default(false).label('Recalcula'),
    idEmpresa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Empresa'),
});
exports.schemaPlanoConta = exports.yupPlanoConta.shape({});
